import React from 'react';
import { Badge, Label } from '@nooz-optics/nooz-components-lib';
import { useMediaQuery } from '../../../../utils/hooks/useMediaQuery';
import { IBlock, ILabel } from '../../../../utils/types/contentful';
import { CategoryMainUsp } from '../../Product/ProductMain/Usp/productMainUsp';
import { Divider } from 'components/UI/Elements/Divider';
import CollectionBreadcrumb from 'components/UI/Navigation/Breadcrumbs/CollectionBreadcrumb';
import { Button } from 'components/UI/Elements';
import { useRecoilState } from 'recoil';
import { sidebarState } from 'utils/recoil/sidebar';
import { FilterButton } from 'components/Ecommerce/CategoriesShopWithNav/Nav/CategoriesShopNav';
import clsx from 'clsx';

export interface ISubCategoryHeaderProps {
  usps: IBlock;
  label: ILabel;
  subLabel: ILabel;
  body: ILabel;
  filters: any;
  filterLabel: any;
  onFilterClick: any;
}

export const SubCategoryHeader = ({
  usps,
  label,
  subLabel,
  body,
  filters,
  filterLabel,
  onFilterClick,
}: ISubCategoryHeaderProps) => {
  const isWindowSmallSize = useMediaQuery('lg');

  return (
    <div className='w-full my-4'>
      <div className='flex mb-4 w-full flex-col items-center'>
        <div className='text-center'>
          {label && (
            <Label
              {...label}
              size='4xl'
            />
          )}
        </div>
        <div className='mt-6 text-center block max-w-144'>
          {subLabel && (
            <Label
              {...subLabel}
              size='base'
            />
          )}
        </div>
      </div>
      <div
        className={clsx(
          [
            'mt-3',
            'lg:mt-5',
            'flex',
            'flex-row',
            'md:justify-center',
            'items-center',
            'md:items-start',
          ],
          'justify-between'
        )}>
        <CategoryMainUsp usps={usps} />

        <div className={'md:hidden my-3'}>
          {filters && filterLabel ? (
            <Button
              type={'white'}
              color={{ classname: 'black' }}>
              <FilterButton
                onClick={onFilterClick}
                filters={filters}
                filterLabel={filterLabel}
              />
            </Button>
          ) : null}
        </div>
      </div>
    </div>
  );
};
